import IRepo from "~/interfaces/repo";
import ConditionalRule from "~/models/conditionalRules/conditionalRule";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import VisualizationSourceDataPoint from "~/models/visualizations/visualizationSourceDataPoint";
import Repo from "~/state/modules/repo";
import FormElement from "../../../formability/form_builder/models/formElements/formElement";
import { DataPointStaticType, StaticDataPointLabels } from "../../../formability/visualizationBuilder/enums/data-point-static-type";

export default class VisualizationDataPointConditionalRule extends ConditionalRule {
  static repo: IRepo<VisualizationDataPointConditionalRule> = new Repo('conditionalRules', VisualizationDataPointConditionalRule);

  get referencedControl(): VisualizationSourceDataPoint {
    return VisualizationSourceDataPoint.repo.findBy(d => d.referenced_client_id === this.referenced_control_id);
  }

  getValueString(id: string): string {
    const element = this.referencedControl;
    if ([StaticDataPointLabels[DataPointStaticType.assignedTo], StaticDataPointLabels[DataPointStaticType.workflowStepCompleter], StaticDataPointLabels[DataPointStaticType.allWorkflowSteps]].includes(element.referenced_client_id)) {
      const staticElement = element.getChoiceComparisonOptions().find(e => e.client_id === id);
      return staticElement ? staticElement.label_title : '';
    }

    if (element.referenced_document_type === "form") {
      const e = FormElement.repo.find(id);
      return e ? e.label_title : '';
    }

    if (element.referenced_document_type === "objectModel") {
      const e = ObjectModelProperty.repo.find(id);
      return e ? e.label_title : '';
    }

    return element ? element.title : '';
  }
}